import { render } from "./MalaMedias.vue?vue&type=template&id=019bbd5c&scoped=true"
import script from "./MalaMedias.vue?vue&type=script&lang=js"
export * from "./MalaMedias.vue?vue&type=script&lang=js"

import "./MalaMedias.vue?vue&type=style&index=0&id=019bbd5c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019bbd5c"]])

export default __exports__